module.exports = __webpack_public_path__ + "static/media/141.185fe9cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/141.jpg
// module id = 939
// module chunks = 0